export const validation = {
  socials: {
    min: 3,
    max: 7
  }
}
